import "./fancy-selection--split";



// WEBPACK FOOTER //
// ./client/src/core/components/fancy-selection/index.js